export enum ApiActionOutcome {
    FAILURE,
    SUCCESS
}
